import { useTranslation } from "react-i18next";
import { TalentCertificate } from "../../talents/talentAPI";
import DocumentState from "./DocumentState";

type Props = {
  certificates: {
    passports: TalentCertificate[];
    workRights: TalentCertificate[];
  };
};

const DocumentStates = ({ certificates }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {certificates.passports.map((certificate) => (
        <DocumentState
          key={certificate.id}
          certificate={certificate}
          label={t("workRights:passport")}
        />
      ))}
      {certificates.workRights.map((certificate) => (
        <DocumentState
          certificate={certificate}
          key={certificate.id}
          label={t("workRights:workRightShort")}
        />
      ))}
    </>
  );
};

export default DocumentStates;
